import { object } from "@/common/object.util";
import ApiGael from "@/services/apiGael.service";
import {
  FETCH_ALL,
  FETCH_ALL_CURSO_CATEGORIAS,
  FETCH,
  FETCH_DOCUMENTOS,
  AUTO_COMPLETE_FETCH_ALL,
  AUTO_COMPLETE_CLEAR_ALL,
  AUTO_COMPLETE_CLIENT_SIDE_FETCH_ALL
} from "@/store/actions/actions.type";
import {
  FETCH_ALL_START,
  SET_ALL,
  SET_ALL_CURSO_CATEGORIAS,
  AUTO_COMPLETE_CLIENT_SIDE_SET_ALL,
  SET,
  FETCH_ALL_END,
  FETCH_START,
  FETCH_END,
  AUTO_COMPLETE_FETCH_ALL_START,
  AUTO_COMPLETE_SET_ALL,
  AUTO_COMPLETE_FETCH_ALL_END,
  AUTO_COMPLETE_UNSET_ALL,
  AUTO_COMPLETE_CLIENT_SIDE_FETCH_END,
  AUTO_COMPLETE_CLIENT_SIDE_FETCH_START
} from "@/store/mutations/mutations.type";

const defaults = Object.freeze({
  curso: {
    id: undefined,
    nome: "",
    cursoCategoria: {
      id: undefined
    },
    carga_horaria: "0.00",
    disciplinas: [],
    documentos: [],
    ativo: 1
  },
  autoCompleteClientSideCursos: {
    data: []
  },
  cursos: {
    current_page: 1,
    per_page: 10,
    data: []
  },
  autoCompleteCursos: {
    data: []
  }
});

const state = {
  curso: object.clone(defaults.curso),
  cursos: object.clone(defaults.cursos),
  cursoCategorias: {
    data: [],
    current_page: 1,
    per_page: 10
  },
  autoCompleteCursos: object.clone(defaults.autoCompleteCursos),
  autoCompleteClientSideCursos: object.clone(defaults.autoCompleteClientSideCursos),
  isFetchingCursos: false,
  isFetchingCurso: false,
  isFetchingAutoCompleteCursos: false,
  isFetchingAutoCompleteClientSideCursos: false
};

const getters = {
  cursos(state) {
    return state.cursos;
  },
  cursoCategorias(state) {
    return state.cursoCategorias;
  },
  isFetchingCursoCategorias(state) {
    return state.isFetchingCursoCategorias;
  },
  curso(state) {
    return state.curso;
  },
  autoCompleteCursos(state) {
    return state.autoCompleteCursos;
  },
  autoCompleteClientSideCursos(state) {
    return state.autoCompleteClientSideCursos;
  },
  isFetchingCursos(state) {
    return state.isFetchingCursos;
  },
  isFetchingCurso(state) {
    return state.isFetchingCurso;
  },
  isFetchingAutoCompleteCursos(state) {
    return state.isFetchingAutoCompleteCursos;
  },
  isFetchingAutoCompleteClientSideCursos(state) {
    return state.isFetchingAutoCompleteClientSideCursos;
  }
};

const actions = {
  [FETCH_ALL_CURSO_CATEGORIAS](context) {
    return new Promise((resolve, reject) => {
      ApiGael.query("cursoCategorias/list")
        .then(response => {
          context.commit(SET_ALL_CURSO_CATEGORIAS, response.data);

          resolve();
        })
        .catch(e => {
          reject(e.response);
        });
    });
  },
  [FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(FETCH_ALL_START);

      ApiGael.query("cursos/list", params)
        .then(response => {
          context.commit(SET_ALL, response.data);
          resolve();
        })
        .catch(e => {
          reject(e.response);
        })
        .finally(() => {
          context.commit(FETCH_ALL_END);
        });
    });
  },
  [FETCH](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(SET, object.clone(defaults.curso));

      if (!params) {
        resolve();
        return;
      }

      context.commit(FETCH_START);

      ApiGael.get("cursos/get", params)
        .then(response => {
          if (response.data.id) {
            context.commit(SET, response.data);
            resolve(response.data);
          } else {
            reject({ notFound: true });
          }
        })
        .catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(FETCH_END);
        });
    });
  },
  [FETCH_DOCUMENTOS](context, id) {
    return new Promise((resolve, reject) => {
      if (!id) {
        resolve(null);
        return;
      }
      ApiGael.get(`cursos/get/${id}/documentos`)
        .then(response => {
          resolve(response.data);
        })
        .catch(e => {
          reject(e);
        });
    });
  },
  [AUTO_COMPLETE_CLIENT_SIDE_FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      context.commit(AUTO_COMPLETE_CLIENT_SIDE_FETCH_START);
      ApiGael.query("cursos/list", { mode: "client-side-completion" })
        .then(response => {
          context.commit(AUTO_COMPLETE_CLIENT_SIDE_SET_ALL, response.data);
          resolve();
        }).catch(e => {
          console.log(e);
          reject(false);
        })
        .finally(() => {
          context.commit(AUTO_COMPLETE_CLIENT_SIDE_FETCH_END);
        });
    });
  },
  [AUTO_COMPLETE_FETCH_ALL](context, params) {
    return new Promise((resolve, reject) => {
      if (params.nome.length < 3) {
        resolve();
        return;
      }

      context.commit(AUTO_COMPLETE_FETCH_ALL_START);
      ApiGael.query("cursos/auto-complete", params)
        .then(response => {
          context.commit(AUTO_COMPLETE_SET_ALL, response.data);
          resolve();
        })
        .finally(() => {
          context.commit(AUTO_COMPLETE_FETCH_ALL_END);
        });
    });
  },
  [AUTO_COMPLETE_CLEAR_ALL](context) {
    return new Promise(resolve => {
      context.commit(AUTO_COMPLETE_UNSET_ALL);
      resolve();
    });
  }
};

const mutations = {
  [FETCH_ALL_START](state) {
    state.isFetchingCursos = true;
  },
  [SET_ALL](state, cursos) {
    state.cursos = cursos;
  },
  [SET_ALL_CURSO_CATEGORIAS](state, cursoCategorias) {
    state.cursoCategorias = cursoCategorias;
  },
  [FETCH_ALL_END](state) {
    state.isFetchingCursos = false;
  },
  [FETCH_START](state) {
    state.isFetchingCurso = true;
  },
  [SET](state, curso) {
    state.curso = curso;
    state.cursoOriginal = object.clone(curso);
  },
  [FETCH_END](state) {
    state.isFetchingCurso = false;
  },
  [AUTO_COMPLETE_CLIENT_SIDE_SET_ALL](state, autoCompleteClientSideCursos) {
    state.autoCompleteClientSideCursos = autoCompleteClientSideCursos;
  },
  [AUTO_COMPLETE_CLIENT_SIDE_FETCH_START](state) {
    state.isFetchingAutoCompleteClientSideCursos = true;
  },
  [AUTO_COMPLETE_CLIENT_SIDE_FETCH_END](state) {
    state.isFetchingAutoCompleteClientSideCursos = false;
  },
  [AUTO_COMPLETE_FETCH_ALL_START](state) {
    state.isFetchingAutoCompleteCursos = true;
  },
  [AUTO_COMPLETE_SET_ALL](state, autoCompleteCursos) {
    state.autoCompleteCursos = autoCompleteCursos;
  },
  [AUTO_COMPLETE_FETCH_ALL_END](state) {
    state.isFetchingAutoCompleteCursos = false;
  },
  [AUTO_COMPLETE_UNSET_ALL](state) {
    state.autoCompleteCursos = object.clone(defaults.autoCompleteCursos);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
